import styled from "styled-components";

export const ToolTipContainer = styled.div`
  display: flex;
  align-items: center;
  justify-items: center;
`;
